import { toLower } from "lodash"
import { call, takeLatest } from "redux-saga/effects"
import { createActions } from "reduxsauce"
import { put, patch, post, del } from "api"

function getApiFunction(method) {
  switch (toLower(method)) {
    case "put":
      return put
    case "post":
      return patch
    case "patch":
      return post
    case "del":
      return del
  }
}

export const { Types, Creators } = createActions({
  callEndpoint: ["url", "method", "body", "callback"],
}, {
  prefix: "ompnt/apiCall/",
})

function* updateSaga({ url, method, body, callback }) {
  try {
    const result = yield call(getApiFunction(method), url, body)
    return yield call(callback, result)
  } catch {
    // do nothing
  }
}

export function* saga() {
  yield takeLatest(Types.CALL_ENDPOINT, updateSaga)
}
